// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"public-header_wrapper__EcwdK","mobileWrapper":"public-header_mobileWrapper__tCGi8","logo":"public-header_logo__2BA3P"};